/**
 * Helpers de texto para busquedas tolerantes.
 *
 * En Centro Sura conviven datos escritos con y sin tilde ("Lider" / "Lider"),
 * y nadie escribe tildes al buscar. Normalizamos ambos lados para que
 * "lider" encuentre "Lider", "andreina" encuentre "Andreina" y "munoz"
 * encuentre "Munoz".
 */

/**
 * Minusculas y sin tildes ni dieresis. No recorta espacios: asi la posicion
 * de cada caracter se corresponde 1 a 1 con el texto original, que es lo que
 * necesitan los resaltados de coincidencia.
 */
export function normalizarTexto(valor) {
  if (valor === null || valor === undefined) return '';
  return String(valor)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/**
 * True si `texto` contiene `consulta`, ignorando tildes y mayusculas.
 * Una consulta vacia coincide con todo.
 */
export function incluyeTexto(texto, consulta) {
  const q = normalizarTexto(consulta).trim();
  if (!q) return true;
  return normalizarTexto(texto).includes(q);
}

/**
 * Posicion de `consulta` dentro de `texto` ignorando tildes y mayusculas,
 * o -1 si no aparece. El indice es valido sobre el texto original.
 */
export function posicionTexto(texto, consulta) {
  const q = normalizarTexto(consulta).trim();
  if (!q) return -1;
  return normalizarTexto(texto).indexOf(q);
}
